
import React from 'react'
import styled from 'styled-components'
import webdevelopment from '../assets/Game-Sc_upscayl_4x_remacri 1.png'
// import websitecover from '../assets/Vector 12.png'
import websitecober1 from '../assets/pngwing 1.png'
// import styled from 'styled-components'
import mobileappimage from '../assets/banner (2).png'
import bannermobile from '../assets/fgame 1.png'
import contimgaemobile from '../assets/BG.png'
import contimageup from '../assets/fgame 1.png'
import serviceImage from '../assets/image 95.png';
import serviceImage1 from '../assets/image 96.png';
import serviceImage2 from '../assets/image 97.png';
import serviceImage3 from '../assets/image 98.png';
import serviceImage4 from '../assets/Group 176.png';
import imageuiux from '../assets/Map.png'
import Rectangle111 from '../assets/Rectangle 111@2x.png'
import Rectangle112 from '../assets/image 101.png'
import Rectangle113 from '../assets/Rectangle 114 (1).png'
import Rectangle114 from '../assets/Rectangle 119 (1).png'
import Rectangle115 from '../assets/Rectangle 117 (1).png'
import Rectangle116 from '../assets/Rectangle 116 (1).png'
import Rectangle117 from '../assets/image 100.png'
import Rectangle118 from '../assets/Rectangle 112 (1).png'
import Rectangle1119 from '../assets/Rectangle 119.png'
import Rectangle001 from '../assets/GameTech1.png'
import Rectangle002 from '../assets/GameTech2.png'
import Rectangle003 from '../assets/GameTech3.png'
import Rectangle004 from '../assets/GameTech4.png'
import Rectangle005 from '../assets/GameTech5.png'
import Rectangle006 from '../assets/GameTech6.png'
import Rectangle007 from '../assets/GameTech7.png'
import Rectangle008 from '../assets/GameTech8.png'
import Rectangle009 from '../assets/GameTech9.png'
import Rectangle010 from '../assets/GameTech10.png'
import { useNavigate } from 'react-router-dom';
// import Rectangle120 from '../assets/Rectangle 120.png'
import { useState } from 'react'

const MainWrapContanier = styled.div``
const MobileAppImage = styled.img`
position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  object-fit: cover;
  z-index: -1;
  @media (max-width:600px){
  width:100%;
  height:auto;
}
@media (min-width:601px) and (max-width:1024px){
  width:100%;
  height:auto;
}
`
const Wrap = styled.div`
  /* position: absolute; */
`



const MobileHead = styled.h1`
  font-size: 70px;
  color:white;
`

const MobileHeadPara = styled.p`
color:white;
margin-top:20px;
`
const Div = styled.div`
position: absolute;
z-index: 100;
top: 200px;
left: 110px;
`
const ContanierHead = styled.div`
  width:100%;
  height:500px;
  /* background-color: red; */
  display:flex;
  justify-content: center;
  align-items: center;
  box-sizing:border-box;
  padding:50px;
  padding-left:150px;
  gap: 40px;
  @media (max-width:600px) {
    width:100%;
    height: auto;
    flex-direction: column;
    padding:10px;
  }
  @media (max-width:600px) {
    
    flex-direction: column-reverse;
    
  }

  @media (min-width:601px) and (max-width:1024px){
    width:100%;
    height: auto;
    flex-direction: column;
    padding:10px;
}
@media (min-width:601px) and (max-width:1024px){
  flex-direction: column-reverse;
}
@media (min-width:1025px) and (max-width:1300px){
  gap:0px
}
@media (min-width:1301px) and (max-width:1440px){
  height:550px;
}
@media (min-width:1441px) and (max-width:2100px){
  height:600px;
}
`
const ContanierRhtHead = styled.h1`
  width: 46%;
  height: 400px;
  /* background-color: yellow; */
  font-size: 60px;
  text-align: center;
  align-items: center;
  padding-top: 100px;
  @media (max-width:600px) {
    width:100%;
    height: auto;
    font-size: 40px;
    padding-top: 20px;
    padding-bottom:20px;
  }
  @media (min-width:601px) and (max-width:1024px){
    width:100%;
    height: auto;
    font-size: 60px;
    padding-top: 20px;
    padding-bottom:20px;
}
@media (min-width:1025px) and (max-width:1300px){
    width:100%;
    height: auto;
    font-size: 60px;
    padding-top: 20px;
    padding-bottom:20px;
}
@media (min-width:1301px) and (max-width:1440px){
    
    height: 500px;
    
}
@media (min-width:1441px) and (max-width:2100px){
  height:550px;
}
`
const ContanierMobile = styled.div`
  width:45%;
  height:400px;
  align-items: center;
  justify-content: center;
  /* background-color: blue; */
  @media (max-width:600px) {
    width:100%;
    height: auto;
    padding-right: 60px;
  }
  @media (min-width:601px) and (max-width:1024px){
    width:90%;
    height: auto;
    
}
@media (min-width:1025px) and (max-width:1300px){
  width:70%;
  height: auto;
}
@media (min-width:1301px) and (max-width:1440px){
    
    height: 500px;
    
}
@media (min-width:1441px) and (max-width:2100px){
  height:550px;
}
`
const MobilePara = styled.p`
font-size: 20px;
margin-top:20px;
color:green;
`
const MobileImage = styled.img`
width:80%;
height:400px;
margin-left: 40px;
@media (max-width:600px){
    
    height:auto;
  }
@media (min-width:1301px) and (max-width:1440px){
    
    height: auto;
    
}
@media (min-width:1441px) and (max-width:2100px){
  width:75%;
  height: auto;
}
`
const ContanierMainMobile = styled.div`
  width:100%;
  height:570px;
  box-sizing: border-box;
  position: relative;
  @media (max-width:600px){
    flex-direction: column;
    width:100%;
    height:auto;
  }
  @media (min-width:601px) and (max-width:1024px){
    flex-direction: column;
    width:100%;
    height:auto;
    
}
@media (min-width:1441px) and (max-width:2100px){
  width:100%;
  height:670px;
}
`
const ContMobImage = styled.img`
width:95%;
height:570px;
margin-left: 35px;
@media (max-width:600px){
    flex-direction: column;
    width:100%;
    height:1100px;
    margin-left:0px;
  }
  @media (min-width:601px) and (max-width:814px){
    flex-direction: column;
    width:100%;
    height:1300px;
    margin-left:0px;
}
@media (min-width:815px) and (max-width:1024px){
  flex-direction: column;
    width:100%;
    height:1420px;
    margin-left:0px;
}
@media (min-width:1441px) and (max-width:2100px){
  width:95%;
  height:670px;
  margin-left: 45px;
}
`
const ContMobImage1 = styled.img`
width:80%;
height:auto;
align-content: center;
justify-content: center;
@media (max-width:600px) {
margin-top:40px;
}
@media (min-width:1025px) and (max-width:1300px){
  width:63%;
}
`
const MobileHeading = styled.h1`
  text-align: center;
color:white;
font-size: 40px;
@media (max-width:600px) {
font-size: 33px;
}
@media (min-width:1025px) and (max-width:1300px){
  font-size: 25px;
}
`
const CreationMain = styled.div`
  position: absolute;
  width:95%;
  box-sizing:border-box;
  flex-direction:center;
  align-items: center;
  justify-content:center;
  height:550px;
  padding:20px;
  display:flex;
z-index: 100;
top: 10px;
left:20px;
/* background-color: red; */

@media (max-width:600px) {
width: 100%;
height:auto;
flex-direction:column;
left:0px;

}
@media (min-width:601px) and (max-width:1024px){
  width: 100%;
height:auto;
flex-direction:column;
left:0px;
}
@media (min-width:1441px) and (max-width:2100px){
  width:95%;
  height:650px;
}
`
const CreationHead = styled.h1`
text-align: center;
color:white;
font-size: 50px;
color: #ebaa32;
@media (max-width:600px) {
font-size: 27px;
margin-top:40px;
}
@media (min-width:1025px) and (max-width:1300px){
  font-size: 25px;
}
`
const CreationPara = styled.p`
color:white;
margin-top: 20px;
line-height: 35px;
font-size: 25px;
@media (max-width:600px) {
/* color: red; */
align-item:center;
text-align: center;
line-height: 43px;
font-size: 15px;
}
@media (min-width:1025px) and (max-width:1300px){
  font-size: 18px;
}
@media (min-width:1441px) and (max-width:2100px){
  line-height: 58px;
  text-align: center;
  align-items: center;
  
}
`
const CreationButton = styled.button`
  width: 150px;
  height: 50px;
  border: solid 1px white; /* White border */
  font-weight: bold;
  box-sizing: border-box ;
  border-radius: 50px;
  font-size: 15px;
  margin-top: 20px;
  cursor: pointer;
  
  

  color: #faf8f8; /* White text color */
  background-color:  rgba(0, 0, 0, 0.2); /* Text shadow for better readability */

  &:hover {
    opacity: 1; /* Full opacity on hover */
  }
  @media (max-width:600px) {
/* color: red; */
align-items: center;
text-align: center;
justify-content:center;

}
@media (min-width: 1442px) and (max-width:2100px)
{
  align-items: center;
  justify-content: center;
  text-align: center;
}
`;

const Container19 = styled.div`
/* background-color: yellow; */
  position: relative;
  margin-top: 10px;
  width: 100%;
  align-items: center;
  z-index: 1;
  box-sizing: border-box;
  height: 900px;
  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  @media screen and (max-width:600px){
    width:100%;
    max-width:99%;
    height: auto;
    height: 2500px;
  }
  @media (min-width:601px) and (max-width:814px){
  width:100%;
    max-width:99%;
    height: auto;
    height: 1350px;
}
@media (min-width:815px) and (max-width:973px){
  width:100%;
    max-width:99%;
    height: auto;
    height: 1350px;
}
@media (min-width:1025px) and (max-width:1300px){
  width:100%;
    max-width:99%;
    height: auto;
    height: 910px;
}
@media (min-width:1301px) and (max-width:1627px){
  width:100%;
    max-width:99%;
    height: auto;
    height: 940px;
}
@media (min-width:1628px) and (max-width:2100px){
  width:100%;
  height:500px;
}
  
`;

const Div3 = styled.div`
 width:100%;
height:auto;
  position: relative;
  background-color:green;
  align-items: center;
  justify-content: center;
  align-items: center;
  @media screen and (max-width:600px){
    width:100%;
    height: auto;
    
  }
`;
const PageContainer2 = styled.div`
  position: relative;
  width: 80%;
  height: 830px;
  z-index: 100;
  /* background-color: red; */
  margin-left: 140px;
  @media screen and (max-width:430px){
  display:flex;
  /* overflow: scroll; */
  height:590px;
  width:90%;
  margin:20px;
  }
`;
const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2rem;
  align-items: center;
  position: absolute;
  top: 3%;
  /* left: 10%; */
  box-sizing: border-box;
  z-index: 1;
  width: 100%;
  
  /* background-color: #0084ff; */
  @media screen and (max-width:600px){
      flex-direction: column;
    width:100%;
    height: auto;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  @media (min-width: 1301px) and (max-width:1440px) {
    gap: 4rem;
  }
`;
const Card = styled.div`
  position: relative;
  background-color: white;
  color: black;
  width: 300px;
  height: 400px;
  padding: 1rem;
  border-radius: 25px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  text-align: center;
  opacity: 0.8;             
  border: 1px solid black;
  
  transition: transform 0.3s ease, box-shadow 0.3s ease, opacity 0.3s ease;

  &:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
    opacity: 1;
   cursor: pointer;
   border: solid 2px #1c1c7a;
    background-color:  #b6b2b2; /* Background color on hover */
    transform: scale(1.05); 
  }

  &:hover img {
     /* Change image color to grayscale on hover */
    
  }

  &:hover h3 {
    color:#1c1c7a; 
  }

  &:hover p {
    color:#1c1c7a;
  }
  @media screen and (max-width:600px){
    width: 300px;
    height: 450px;
    margin-right:10px;
    
    
    /* margin-left: 20px;
    margin-right:20px; */

  }
  
`;
const CardDescription = styled.p`
  font-size: 1rem;
  color: black;

  @media screen and (max-width:600px) {
    align-item:center;
text-align: center;
line-height: 22px;
font-size: 15px;
    
  }
`;
const CardTitle = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
  @media screen and (max-width:600px) {
    font-size: 25px;
    align-items: center;
    text-align: center;
  }
`;
const CardImage = styled.img`
  width: auto;
  height: auto;
  object-fit: cover;
  margin-bottom: 1rem;
  color: black;
`;
const HeaderWeb = styled.h1`
  color: black;
  margin-top: 30px;
  font-size: 45px;
  margin-bottom: 1rem;
  box-sizing: border-box;
  justify-content: center;
  text-align: center;
  @media screen and (max-width:600px) {
    margin-left: 0%;
    margin-top: 0px;
    font-size: 16px;
  }
  @media (min-width:601px) and (max-width:1024px){
 margin-left: 0%;
    margin-top: 0px;
    font-size: 24px;
}
@media (min-width:1441px) and (max-width:2100px){
  margin-left: 100px;
  margin-right: 100px;
}
`;
const Container20 = styled.div`
box-sizing: border-box;
width: 100%;
height:100%;
align-items: center;
text-align: center;
justify-content: center;
/* background-color: red; */
@media (min-width:1025px) and (max-width:1300px){
  
    width: 100%;
    height:auto;
    
}
`
const ImageUiUx = styled.img`
  width:100%;
  align-items: center;
  height:auto;
  padding-left: 60px;
  padding-right:60px;
  object-fit: cover;
  margin-top:20px;
  
  justify-content: center;
  @media screen and (max-width:600px) {
    margin: 0%;
    width: 100%;
    height:auto;
   
    margin-top:30px;
    margin-bottom:30px;
  }
  @media (min-width:601px) and (max-width:1024px){
  margin: 0%;
    width: 100%;
    height:auto;
    margin-top:30px;
    margin-bottom:30px;
}
@media (min-width:601px) and (max-width:1024px){
  margin: 0%;
    width: 100%;
    height:auto;
    margin-top:30px;
    margin-bottom:30px;
}
@media (min-width:1301px) and (max-width:1440px){
  width:100%;
  align-items: center;
  height:auto;
  object-fit: cover;
}
@media (min-width:1441px) and (max-width:2100px){
  width:100%;
  height:auto;
}

`
const PeraWeb = styled.p`
  color: black;
  margin-top: 10px;
  font-size: 25px;
  margin-bottom: 1rem;
  text-align: center;
  box-sizing: border-box;
  align-items: center;
  
  @media (max-width:600px) {
    margin-left: 0%;
    align-item:center;
text-align: center;
line-height: 25px;
font-size: 14px;
margin:10px;
    
  }
   @media (min-width:601px) and (max-width:1024px){
 margin-left: 0%;
    align-item:center;
    font-size: 16px;
text-align: center;

margin:10px;
}
`;
const Container21 = styled.div`
  width: 100%;
 
 height:700px;
 box-sizing: border-box;
 /* background-color:green; */
 justify-content: center;
 align-items: center;
 @media (max-width:600px) {
   width: 100%;
   height:auto;
 }
  @media (min-width:601px) and (max-width:1024px){
 width: 100%;
   height:auto;
}
@media (min-width:1025px) and (max-width:1300px){
 width: 100%;
   height:800px;
}
@media (min-width:1778px) and (max-width:2100px){
  
  height: 520px;
}
`
const TabNavigation = styled.div`
margin-top:40px;
  width:90%;
  height:480px;
  align-items: center;
  text-align:center;
  justify-content:center;
  background-color: #d4d4d4;
  margin-left: 60px;
  @media (max-width:600px) {
    width: 100%;
    height:auto;
    
    margin-left: 0%;
  }
  @media (min-width:601px) and (max-width:1024px){
  width: 100%;
    height:auto;
    
    margin-left: 0%;
}
@media (min-width:1441px) and (max-width:2100px){
  
  align-items: center;
  text-align:center;
  justify-content:center;
    margin-left:80px;
}
@media (min-width:1778px) and (max-width:2100px){
  
  height: 270px;
}

`

const Dflex = styled.ul`
display: flex;
text-decoration: none;
gap:2px;
/* display: none; */
list-style-type: none;
text-align: center;
align-items: center;
padding:3px;
margin-left:5px;
@media (max-width:600px) {
   margin-left: 0px;
  }
  @media (min-width:601px) and (max-width:1024px){
  
    
    margin-left: 0%;
}
`
const FlexFill = styled.li`
text-decoration: none;
background-color: ${props => (props.active ? '#0c0ce7' : 'white')};
color:${(props => (props.active ? 'white' : 'black'))};
/* border: 1px solid black; */
width: 50%;
height: 50px;
/* color:white; */
text-align: center;
align-items: center;
padding-top:10px;
font-size: 25px;
font-weight: bold;
cursor: pointer;
border-radius: 5px;
/* display: none; */
@media (max-width:600px) {
   margin-left: 0px;
  }


`


const TabContents = styled.div`
/* background-color:pink; */
justify-content: center;
align-items: center;
text-align: center;
width: 100%;
  height:auto;
display: ${props => (props.show ? 'block' : 'none')};
@media (max-width:600px){
  width: 100%;
  height:auto;
  
  
}
@media (min-width:601px) and (max-width:1024px){
  
   
  align-items: center;
  text-align: center;
  justify-content: center;
    width: 100%;
  height:auto;
}
@media (min-width:1025px) and (max-width:1300px){
  flex-direction: flex;
width: 100%;
  height: auto;
  align-items: center;
  text-align: center;
  justify-content: center;
}

`
const TabContents1 = styled.div`

display: ${props => (props.show ? 'block' : 'none')};
`


const HeadTab1 = styled.h1`
font-size: 15px;
`
/* const ParaTab1 = styled.p`` */
/* const ShowConten = styled.div`` */
const CardTools = styled.div`
  width: 150px;
  height: 150px;
  background-color: white;
  margin: 10px;
  margin-left: 70px;
  align-items: center;
  text-align: center;
  margin-top: 40px;
  border-radius: 20px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* Added transition for smooth effect */

  &:hover {
    transform: scale(1.05); /* Scale up slightly on hover */
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2); /* Darker shadow on hover */
  }
`;

const CardTools1 = styled.div`
  width:150px;
  height:150px;
  background-color:white;
  margin:10px;
  margin-left: 70px;
  align-items: center;
  text-align: center;
  margin-top: 40px;
  border-radius: 20px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* Added transition for smooth effect */

&:hover {
  transform: scale(1.05); /* Scale up slightly on hover */
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2); /* Darker shadow on hover */
}

@media (max-width:600px){
  margin:0%;
  margin:20px;
  align-items: center;
  text-align: center;
  justify-content: center;
}
@media (min-width:601px) and (max-width:1024px){
  
   
 margin:0%;
  margin:20px;
  align-items: center;
  text-align: center;
  justify-content: center;
}
@media (min-width:1300px) and (max-width:1440px){
  
   
  margin:0%;
  margin:20px;
 }
@media (min-width:1441px) and (max-width:2100px){
  
   
  margin:0%;
   margin:25px;
   align-items: center;
   text-align: center;
   justify-content: center;
 }
`;


const TechImage = styled.img`
width: 100px;
height:100px;
margin-top:10px;
align-items: center;
`
const TechImage2 = styled.img`
width: 100px;
height:30px;
margin-top:60px;
align-items: center;
`
const TechImage1 = styled.img`

margin-top:10px;
align-items: center;
`
const TechImage5 = styled.img`
width:110px;
height:120px;
margin-top:10px;
align-items: center;
`
const TechImage11 = styled.img`
width: 100px;
height:30px;
margin-top:60px;
align-items: center;
`
const Div2 = styled.div`
  width: 100%;
  align-items: center;
  text-align: center;
  justify-content: center;
  /* background-color: yellow; */
  height: auto;
  box-sizing: border-box;
  flex-wrap: wrap;
display: flex;
@media (max-width:600px) {
flex-direction: flex;
width: 100%;
  height: auto;
  align-items: center;
  text-align: center;
  justify-content: center;
}
@media (min-width:601px) and (max-width:1024px){
  flex-direction: flex;
width: 100%;
  height: auto;
  align-items: center;
  text-align: center;
  justify-content: center;
}
@media (min-width:1025px) and (max-width:1300px){
  flex-direction: flex;
width: 100%;
  height: auto;
  align-items: center;
  text-align: center;
  justify-content: center;
}
@media (min-width:1441px) and (max-width:2100px){
  
width: 100%;
  height: auto;
  align-items: center;
  text-align: center;
  justify-content: center;
}

`;
const Div0 = styled.div`
  align-items: center;
  text-align: center;
display: flex;
margin-left:232px;
/* flex-direction: row; */
`;



// const MobileAppImage1 = styled.img`
// position: absolute;
// top: 0;
// right: 0;
//   width: 646px;
//   height: 376px;
//   object-fit: cover;
//   z-index: 100;
//   margin-top: 305px;

// `
const MobileAppImage2 = styled.img`
position: absolute;
top: 200px;
left: 220px;
  width: 200px;
  height: 68px;
  object-fit: cover;
  z-index: 100;
  @media (max-width:600px) {
  top:110px;
  left: 60px;
  width: 130px;
  height: 40px;
}
@media (min-width:601px) and (max-width:1024px){
  top:110px;
  left: 60px;
  width: 150px;
  height: 42px;
}
@media (min-width:1025px) and (max-width:1300px){
  top:180px;
  left: 70px;
  width: 150px;
  height: 42px;
}
   @media (min-width:1441px) and (max-width:2200px){
  font-size:75px;
  top: 270px;
  left:330px;
}
`

const Div8 = styled.div`
 
`


const HeadH2 = styled.h1`
  position: absolute;
  z-index: 100;
  left: 50px;
  color:black;
  
  font-size: 70px;
  // text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.7); /* Adding shadow effect */
  top: 300px;
  text-align: center;
  @media (max-width:600px) {
  font-size:20px;
  top: 170px;
}
@media (min-width:601px) and (max-width:1024px){
  font-size:25px;
  top: 170px;
}
@media (min-width:1025px) and (max-width:1300px){
  font-size:25px;
  top: 250px;
}
  @media (min-width:1441px) and (max-width:2200px){
  font-size:75px;
  top: 370px;
  left:150px;
}
`
const DisButton = styled.button`
  border: none;
  align-items: center;
  text-align: center;
  padding: 20px;
  font-size: 18px;
  font-weight: bold;
  border-radius: 50px;
  cursor: pointer;
  margin-top: 30px;
  margin-left: 20px;
  background-color: #2020cf;
  color:white
`
const ImageTappTAG = styled.div`

width:60%;
box-sizing: border-box;
align-content: center;
text-align: center;
justify-content: center;
height:530px;
/* background-color:blue; */
margin-bottom:40px;

@media (max-width:600px) {
width: 100%;
height: auto;
}
@media (min-width:601px) and (max-width:1024px){
  width: 100%;
  height: auto;
  margin-bottom:20px;

}
@media (min-width:1301px) and (max-width:1440px){
  width: 48%;
  height: auto;
  margin-bottom:20px;

}
@media (min-width:1441px) and (max-width:2100px){
  width:40%;
  height:auto;
}
`
const AllContanier = styled.div`

  width:60%;
  height:550px;
  box-sizing:border-box;
padding-top:40px;

/* background-color: #464343; */
@media (max-width:600px) {
width: 100%;
height:auto;
flex-direction:column;
padding-top:0px;
align-items: center;
text-align: center;
justify-content: center;
}
@media (min-width:601px) and (max-width:1024px){
  width: 100%;
height:auto;
flex-direction:column;
padding-top:0px;
align-items: center;
text-align: center;
justify-content: center;
}
@media (min-width: 1442px) and (max-width:2100px)
{
  align-items: center;
  justify-content: center;
  text-align: center;
}
`;


const GameDevelopment = () => {
  const navigation = useNavigate();
  const [toggle, setToggle] = useState(1)

  function updateToggle(id) {
    setToggle(id)
  }
  const cards = [
    { title: 'Game Strategy', description: 'A successsful game development strategy involves a balanced approach that combines creativity, technical expertise, and project management. it begins with a clear understanding of the target audience , market trends, and competion, followed by the definition of a unique selling proposition (USP) that sets the game', img: serviceImage },
    { title: 'Game Design', description: 'In game design, the creative process begins with conceptualization, where the deisgner defines the games core mechanics, story, and bojectives. This involes identifying the target audience and market trends to ensure the game appeals to players. The next step is prototyping, where the designer creates a rough', img: serviceImage1 },
    { title: 'Game Development', description: 'Game development is the process of creating a game for PCs, console, or mobile devices. it involes several stages, including concept and design, where the game ideas is flashed out and its mechanics are decided upon. The next stage is programming, where the games code is written in a programming language such as C# or java.', img: serviceImage2 },
    { title: 'User Acquisition', description: 'User acquistion is the process of attracting and recuiting new users to product, service, or platform. it involes strategies to incrase visibility, drive traffic, and persuade potential users to try out the offering.', img: serviceImage3 },
    { title: 'Game Analytics', description: 'Game anayltics is the process of collecting and analyzing data on player behavior and performance in a game to gain insights that can inform game  development, marketing, and monetization strategies. This includes tracking metrics such player retention, engagment, and revenue generation, as well as analyzing data on player demogaphics, performances', img: serviceImage4 },

  ];
  return (
    <>
      <Wrap>
        <MainWrapContanier>
          <Div8>

            <MobileAppImage src={webdevelopment} alt='Background' />
            {/* <MobileAppImage1 src={websitecover} alt = 'Background'/> */}
            <MobileAppImage2 data-aos="fade-right" src={websitecober1} alt='Background' />
            <HeadH2 data-aos="fade-down" data-aos-duration="3000">GAMES<br></br> DEVELOPMENT</HeadH2>

          </Div8>


          <ContanierHead>
            <ContanierRhtHead data-aos="fade-right">
              We Love Building Awesome Games!
              <MobilePara data-aos="fade-right">View Work</MobilePara>
              <DisButton onClick={() => navigation("/ContactUs")} data-aos="fade-right">Discus Your Project</DisButton>
            </ContanierRhtHead>

            <ContanierMobile>
              <MobileImage data-aos="flip-left" src={bannermobile} alt='Image not found' />
            </ContanierMobile>
          </ContanierHead>


          <ContanierMainMobile>

            <ContMobImage src={contimgaemobile} alt='Image Not Found' />
            <CreationMain>

              <ImageTappTAG>
                <ContMobImage1 data-aos="flip-left" src={contimageup} alt='Image Not Found' />
              </ImageTappTAG>
              <AllContanier>
              
              
              <MobileHeading data-aos="fade-right">Our Latest Creations</MobileHeading>
                <CreationHead data-aos="fade-right">DUNGEON RAID</CreationHead>
                <CreationPara data-aos="fade-right">The iconic Clarion fashion dress! This stunning garment is a staple in every fashion enthusiast's
                  wardrobe. With its sleek, streamlined silhouettle and intricately embroidered design, the Clarion dress exudes
                  elegance and sophistication. Made from the finest materials, it hugs the body in all the right places,
                  accententuating the wearer's curves with precision.
                </CreationPara>
                <CreationButton data-aos="fade-right">Read More</CreationButton>
              </AllContanier>
            </CreationMain>

          </ContanierMainMobile>

          <Container19>

            <HeaderWeb data-aos="fade-right">Our Process</HeaderWeb>

            <Div3>
              

                <CardContainer>
                  {cards.map((card, index) => (
                    <Card
                      data-aos="flip-left"
                      data-aos-easing="ease-out-cubic"
                      data-aos-duration="2000"
                      key={index}>
                      <CardImage src={card.img} alt={card.title} />
                      <CardTitle>{card.title}</CardTitle>
                      <CardDescription>{card.description}</CardDescription>
                    </Card>
                  ))}
                </CardContainer>
              
            </Div3>
          </Container19>

          <Container20>
            <HeaderWeb data-aos="fade-right">Kicktart your Project with Big Heap Tech Reliable Mobile Game Development Process</HeaderWeb>
            <PeraWeb data-aos="fade-right">Big your project journey with Big Heap Tech trusted App Development process. We follow a
              straightforward procedure to ensure efficent progress </PeraWeb>

            <ImageUiUx src={imageuiux} alt='NOT FOUND' />
          </Container20>

          <Container21>
            <HeaderWeb data-aos="fade-right">  Game Development Tools and Technologies</HeaderWeb>
            <PeraWeb data-aos="fade-right">With our top technologies, your seccess is guaranteed  </PeraWeb>

            <TabNavigation>
              <Dflex>
                <FlexFill
                  onClick={() => updateToggle(1)}
                  active={toggle === 1}
                >
                  Tools
                </FlexFill>
                <FlexFill
                  onClick={() => updateToggle(2)}
                  active={toggle === 2}
                >
                  Technologies
                </FlexFill>

              </Dflex>

              <TabContents show={toggle === 1}>
                <Div2>
                  <CardTools1 data-aos="flip-left">
                    <TechImage5 src={Rectangle111} alt='Image Not fOUND' />

                  </CardTools1>
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle112} alt='Image Not fOUND' />

                  </CardTools1>
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle113} alt='Image Not fOUND' />

                  </CardTools1>
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle114} alt='Image Not fOUND' />

                  </CardTools1>
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle115} alt='Image Not fOUND' />

                  </CardTools1>

                

                
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle116} alt='Image Not fOUND' />

                  </CardTools1>
                  <CardTools1 data-aos="flip-left">
                    <TechImage11 src={Rectangle117} alt='Image Not fOUND' />

                  </CardTools1>
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle118} alt='Image Not fOUND' />

                  </CardTools1>


                </Div2>

              </TabContents>

              <TabContents show={toggle === 2}>
                <Div2>
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle001} alt='Image Not fOUND' />

                  </CardTools1>
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle002} alt='Image Not fOUND' />

                  </CardTools1>
                  
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle004} alt='Image Not fOUND' />

                  </CardTools1>
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle005} alt='Image Not fOUND' />

                  </CardTools1>

               
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle006} alt='Image Not fOUND' />

                  </CardTools1>
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle007} alt='Image Not fOUND' />

                  </CardTools1>
                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle008} alt='Image Not fOUND' />

                  </CardTools1>


                  <CardTools1 data-aos="flip-left">
                    <TechImage1 src={Rectangle010} alt='Image Not fOUND' />

                  </CardTools1>


                </Div2>
              </TabContents>








            </TabNavigation>
          </Container21>




        </MainWrapContanier>
      </Wrap>
    </>
  )
}

export default GameDevelopment
